import { IAppState } from '../../../AppModulesWrapper';
import { EBetPositionStatus } from '../../types/reducers/betPosition';

export function selectBetPositionStatus(state: IAppState): EBetPositionStatus {
  const {
    betPosition: { status },
  } = state.servicePickerWidget;

  return status;
}
